import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

// Components
import { If } from '../../../../../../../deprecated/Conditionals'
import Format from '../../../../../../shared/Format'
import Text from '../../../../../../shared/Text'
import List from '../../../../../../shared/List'
import PrequalAvatar from '../../PrequalAvatar'
import LoanTerm from '../../LoanTerm'

// Styles
import styles from './Prequal.module.scss'

// Utils
import { formatAbbrCurrency } from 'src/helpers/formatters'
import { format, parseISO } from 'date-fns'

const propTypes = {
  className: PropTypes.string
}

const Prequal = ({
  adjustable,
  amount,
  armYearsInitial,
  className,
  expirationDate,
  fromDate,
  loanOfficerAvatarUri,
  loanType,
  payment,
  rate
}) => {
  return (
    <div data-qa='Prequal' className={classnames(styles.root, className)}>
      <PrequalAvatar className={classnames(styles.avatar)} src={loanOfficerAvatarUri} />

      <div className={styles.details}>
        <If condition={fromDate}>
          <Text variant='neutralCool' variantCount='900' paragraph>
            <FormattedMessage
              id='Affordability.prequalDetail.heading'
              defaultMessage='Pre-Qual from {date}:'
              values={{
                date: format(parseISO(fromDate), 'MMMM yyyy')
              }}
            />
          </Text>
        </If>

        <If condition={payment}>
          <Text size='xs' variant='neutralCool' variantCount='700'>
            <FormattedMessage
              id='Affordability.prequalDetail.payment'
              defaultMessage='{payment}/mo (principal & interest)'
              values={{
                payment: formatAbbrCurrency(payment)
              }}
            />
            <If condition={adjustable && armYearsInitial}>
              {' '}
              <FormattedMessage
                id='Affordability.prequalDetail.adjustable'
                defaultMessage='for first {years} years'
                values={{ years: armYearsInitial }}
              />
            </If>
          </Text>
        </If>

        <List.Bulleted.Inline className={styles.terms} itemClass={styles.term}>
          <Text element='span' size='xs' variant='neutralCool' variantCount='700'>
            {loanType}
          </Text>
          <Text element='span' size='xs' variant='neutralCool' variantCount='700'>
            <LoanTerm />
          </Text>
          {/* when creating buyer with prequal in customer admin, estimated rate is optional. If it is not set, it results in rate being NaN here */}
          {!isNaN(rate) && (
            <Text element='span' size='xs' variant='neutralCool' variantCount='700'>
              <Format.Rate value={rate} />
            </Text>
          )}
        </List.Bulleted.Inline>

        <If condition={expirationDate}>
          <Text size='xs' variant='neutralCool' variantCount='700'>
            <FormattedMessage
              id='Affordability.prequalDetail.expiration'
              defaultMessage='Expires {date}'
              values={{
                date: expirationDate
              }}
            />
          </Text>
        </If>
      </div>

      <Text className={styles.amount} variant='success' size='xl'>
        {formatAbbrCurrency(amount)}
      </Text>
    </div>
  )
}

Prequal.propTypes = propTypes

export default Prequal
